import React, { useState } from 'react';

const ExportOptionsModal = ({ isOpen, onClose, onConfirmExport, availableFields }) => {
    // Initialize all fields to be selected by default
    const [selectedFields, setSelectedFields] = useState(
        availableFields.map(field => field.key)
    );

    const handleCheckboxChange = (fieldKey) => {
        setSelectedFields(prev => 
            prev.includes(fieldKey) 
                ? prev.filter(key => key !== fieldKey)
                : [...prev, fieldKey]
        );
    };

    const handleConfirm = () => {
        if (selectedFields.length === 0) {
            alert("Please select at least one field to export.");
            return;
        }
        onConfirmExport(selectedFields);
    };

    if (!isOpen) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-content" style={{maxWidth: '600px'}}>
                <h3>Select Fields to Export</h3>
                <div className="export-fields-grid">
                    {availableFields.map(field => (
                        <div key={field.key} className="form-field-checkbox">
                            <input
                                type="checkbox"
                                id={`export-${field.key}`}
                                checked={selectedFields.includes(field.key)}
                                onChange={() => handleCheckboxChange(field.key)}
                            />
                            <label htmlFor={`export-${field.key}`}>{field.label}</label>
                        </div>
                    ))}
                </div>
                <div className="form-actions" style={{ justifyContent: 'flex-end', marginTop: '1.5rem' }}>
                    <button type="button" className="cancel-button" onClick={onClose}>Cancel</button>
                    <button type="button" className="submit-button" onClick={handleConfirm}>Confirm & Export</button>
                </div>
            </div>
        </div>
    );
};

export default ExportOptionsModal;